<template>
  <div>
    <div class="bg" style="padding-bottom: 20px">
      <FxedTop ref="fxedTop"></FxedTop>
    </div>
    <div class="pageTitle">
      <div class="sort"></div>
      <div class="currentLocation">当前位置：首页 > 课程小节详情</div>
    </div>
    <div class="mian">
      <div class="title">
        <div class="titleTxt">{{ sectionInfo.name }}</div>
      </div>
      <div class="container" style="margin-bottom: 40px">
        <div class="containent">
          <div class="videoContext">
            <!-- <FaceMatch
                ref="faceMatch"
                :classId="sectionInfo.classId"
                :classSectionId="sectionInfo.classSectionId"
                :schoolClassId="groupInfo.schoolClassId"
                @close="closeFaceMatch"></FaceMatch> -->
            <video
              ref="myVideo"
              :src="sectionInfo.typeConfig.video_url"
              @error="videoErrorCallback"
              @timeupdate="bindtimeupdate"
              @contextmenu="contextmenu"
              @ended="ended"
              @play="onVideoPlay"
              @pause="onVideoPause"
              controlsList="nodownload noplaybackrate"
              disablePictureInPicture
              controls></video>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { IMAGES_PATH } from "@/utils/config2.js";
import {
  getinsertForumComment,
  getcomment,
  getWXDZTX,
  sectionComplete,
  uploadSectionProgress,
  getClassGroupDetail,
} from "@/api/wkApi.js";

import FxedTop from "@/components/FxedTop";
import Footer from "@/components/Footer";
import FaceMatch from "@/components/faceMatch";

export default {
  components: {
    FxedTop,
    Footer,
    FaceMatch,
  },
  data() {
    return {
      images1: IMAGES_PATH + "/images/yuan.png",
      videoIcon1: IMAGES_PATH + "/images/microlecture/videoIcon1.png",
      videoIcon2: IMAGES_PATH + "/images/microlecture/videoIcon2.png",
      videoIcon3: IMAGES_PATH + "/images/microlecture/videoIcon3.png",
      videoIcon4: IMAGES_PATH + "/images/microlecture/videoIcon4.png",
      titlebg: IMAGES_PATH + "/images/microlecture/titlebg.png",
      videoSumbit: IMAGES_PATH + "/images/microlecture/videoSumbit.png",
      noPraise: IMAGES_PATH + "/images/microlecture/noPraise.png",
      okPraise: IMAGES_PATH + "/images/microlecture/videoIcon3.png",
      src: "",
      sectionIsStar: false,
      danmuList: [],
      groupInfo: {},
      inputValues: "",
      options: {},
      currentTime: 0,
      duration: 0,
      userTxList: {},
      total: "",
      userStatus: {},
      isMultiple: false,
      commentsList: [],
      comment_total: "",
      comment_pageNum: 1,
      sectionInfo: {
        typeConfig: {},
      },
      isTo: true,
      timeStamp: 10,
      lastTime: 0,
      classGroupInfo: {},
      faceVerificationFrequency: 0,
      isPlaying: false,
    };
  },
  created() {
    this.options = this.$route.query;
    this.timeStamp = 10;
    // 获取小节内容

    this.getSectionInfo();
  },
  // mounted() {
  //   this.handleVisibilityChange();
  // },
  // beforeDestroy() {
  //   // 清理事件监听器
  //   document.removeEventListener("visibilitychange", this.onVisibilityChange);
  // },
  methods: {
    handleVisibilityChange() {
      // 绑定事件监听器
      this.onVisibilityChange = this.handleVisibilityChangeCallback.bind(this);
      document.addEventListener("visibilitychange", this.onVisibilityChange);
    },
    handleVisibilityChangeCallback() {
      if (document.visibilityState === "hidden") {
        // 页面不可见，暂停视频
        if (this.$refs.myVideo && !this.$refs.myVideo.paused) {
          this.$refs.myVideo.pause();
          this.isPlaying = false;
          console.log("页面切换，视频已暂停");
        }
      }
    },
    // 视频开始播放
    onVideoPlay() {
      this.isPlaying = true;
      console.log("视频开始播放");
    },
    // 视频暂停
    onVideoPause() {
      this.isPlaying = false;
      console.log("视频已暂停");
    },

    contextmenu(e) {
      e.returnValue = false; //禁用右键
    },
    closeFaceMatch() {
      this.$confirm("人脸比对失败, 请调整好摄像头重新抓拍", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).finally(() => {
        try {
          this.$router.go(-1);
        } catch (error) {
          this.$router.push("/");
        }
      });
    },
    comment() {
      let params = {
        classId: this.options.classId,
        pageNo: this.comment_pageNum,
        sectionId: this.options.sectionId,
        pageSize: 10,
      };
      getcomment(params).then((res) => {
        this.comment_total = res.result.total;
        if (this.comment_pageNum === 1) {
          this.commentsList = res.result.list;
        } else {
          this.commentsList = [...this.commentsList, ...res.result.list];
        }
      });
    },
    // 上拉触底
    onReachBottom() {
      if (Math.ceil(this.comment_total / 10) + 1 === this.comment_pageNum) {
        return this.$message.warning("已经到底了哦");
      } else {
        this.comment_pageNum++;
        this.comment();
      }
    },
    // 获取当前小节内容
    getSectionInfo() {
      getClassGroupDetail(this.$route.query.classGroupId).then((res) => {
        this.groupInfo = res.result;
        this.classGroupInfo = res.result;
        if (res.result.classList.length > 0) {
          res.result.classList[0].classSectionList.forEach((item) => {
            if (
              item.classSectionId == this.$route.query.sectionId &&
              item.classId == this.$route.query.classId
            ) {
              item.typeConfig.video_url = item.typeConfig.video_url.replace(
                "https://xzzhuanji.cn/ework/",
                "https://zwyun.xzzhuanji.cn:18443/zhuanji/"
              );

              this.sectionInfo = item;
              // 默认继续上次播放
              this.$nextTick(() => {
                this.videoContext = this.$refs.myVideo;
                this.videoContext.currentTime = item.learningDuration;
                this.currentTime = item.learningDuration;
              });

              this.faceVerificationFrequency = this.getNextCaptureTime(
                item.learningDuration ? item.learningDuration : 0
              );
            }
          });
        }
      });
    },

    // 计算下一次抓拍时间
    getNextCaptureTime(currentTime) {
      if (currentTime == 0 || !currentTime) {
        return 0;
      }

      // 递归计算抓拍时间
      return this.calculateNextCaptureTime(currentTime, 0);
    },

    // 递归计算下一次抓拍时间
    calculateNextCaptureTime(currentTime, index) {
      const frequency = this.classGroupInfo.faceVerificationFrequency * 60; // 转换为秒
      const captureTime = frequency * index;

      console.log(`检查第${index + 1}次抓拍时间: ${captureTime}秒`);

      // 如果当前时间小于等于这次抓拍时间，返回这次抓拍时间
      if (currentTime <= captureTime) {
        console.log(`找到下一次抓拍时间: ${captureTime}秒`);
        return captureTime;
      }

      // 如果已经超过最大抓拍次数（这里设置为5次），返回null或最后一个时间
      if (index >= 20) {
        console.log("已超过最大抓拍次数");
        return null;
      }
      // 递归检查下一次抓拍时间
      return this.calculateNextCaptureTime(currentTime, index + 1);
    },
    // 旧
    multiple() {
      this.isMultiple = !this.isMultiple;
    },
    bindButtonRate(e) {
      var rate = e.currentTarget.dataset.rate;
      this.videoContext.playbackRate(Number(rate));
      this.isMultiple = false;
    },
    // 人脸识别后跳转详情
    faceSuccess() {
      let video = this.$refs.myVideo;
      video.play();
    },
    ended() {
      console.log("视频播放结束");
      // 学习完成后不在上报完成小节
      sectionComplete(this.options).then((res) => {
        this.isTo = false;
      });
    },
    // 监听播放进度
    bindtimeupdate(e) {
      let video = this.$refs.myVideo;
      // 学习完成后可以拖动进度条
      if (this.sectionInfo.isComplete != 1) {
        if (video.currentTime > this.currentTime + 2) {
          this.$message.warning("课程未完成前请勿拖动进度条");
          video.currentTime = this.currentTime;
        }
        // 是否开启人脸验证,  如果开启了人脸验证，则判断是否验证通过，如果通过，则可以播放，否则不能播放
        if (
          this.classGroupInfo.isFaceVerification == 1 &&
          this.classGroupInfo.faceVerificationFrequency > 0 &&
          this.currentTime > this.faceVerificationFrequency
        ) {
          this.faceVerificationFrequency =
            this.faceVerificationFrequency +
            this.classGroupInfo.faceVerificationFrequency * 60;
          // this.$refs.faceMatch.uploadFaceImg();
        }

        // 每播放10秒上传课程进度
        if (this.currentTime > this.timeStamp) {
          this.timeStamp = this.currentTime;
          this.timeStamp = this.timeStamp + 15;
          uploadSectionProgress({
            ...this.options,
            learningDuration: this.currentTime,
          });
        }
      }

      this.currentTime = e.target.currentTime;
      this.duration = e.target.duration;
    },
    // 获取随机颜色
    getRandomColor() {
      const rgb = [];
      for (let i = 0; i < 3; ++i) {
        let color = Math.floor(Math.random() * 256).toString(16);
        color = color.length === 1 ? "0" + color : color;
        rgb.push(color);
      }
      return "#" + rgb.join("");
    },
    bindSendDanmu() {
      let params = {
        ...this.options,
        content: this.inputValues,
        videoTime: parseInt(this.currentTime),
      };
      if (!this.inputValues) {
        return this.$message.warning("请输入你的观点");
      }
      if (this.currentTime > 0) {
        getinsertForumComment(params).then((res) => {
          if (res.code == 200) {
            this.inputValues = "";
            this.$message.success("发表成功");
            this.comment();
          } else {
            this.$message.error("提交失败请检查输入值是否合法");
          }
        });
      } else {
        this.$message.warning("只有观看视频的时候才能发表评论哦");
      }
    },

    videoErrorCallback(e) {
      console.log("视频错误信息:");
      console.log(e.detail.errMsg);
    },

    formatDateTime(date, format = "YYYY-MM-DD HH:mm:ss") {
      const d = new Date(date);

      if (isNaN(d.getTime())) {
        throw new Error("无效的日期格式");
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");
      const milliseconds = String(d.getMilliseconds()).padStart(3, "0");

      return format
        .replace("YYYY", year)
        .replace("MM", month)
        .replace("DD", day)
        .replace("HH", hours)
        .replace("mm", minutes)
        .replace("ss", seconds)
        .replace("SSS", milliseconds);
    },
  },
};
</script>

<style scoped>
.videoContext {
  position: relative;
}
img {
  display: block;
}
div,
img {
  box-sizing: border-box;
}
.containent {
  position: relative;
  width: 100%;
  background: #f6f6f6;
}
video {
  width: 1360px;
  border-radius: 5px;
  overflow: hidden;
  display: block;
  position: relative;
  transition: all 0.3s ease;
  transform-origin: center;
}

.title {
  width: 100%;
  height: 120px;
  background-color: #fff;
  font-size: 38px;
  color: #4a4a4a;
  line-height: 120px;
  padding-left: 40px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
.titleTxt {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.detail {
  width: 100%;
  height: 140px;
  background-image: linear-gradient(#fff, #f6f6f6);
  padding-left: 40px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.user {
  font-size: 24px;
  color: #5e5e5e;
  display: flex;
  align-items: center;
}
.user .icon {
  margin-right: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.user .switchTab {
  width: 66px;
  height: 38px;
}
.user .urls {
  display: flex;
}
.user .icon img {
  width: 40px;
  height: 40px;
  margin-right: 8px;
}
.user .urls img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  border-radius: 50%;
}
.comments_edit {
  background-color: white;
  width: 100%;
  border-radius: 15px;
}
.comments {
  /* width: 686px; */
  width: 90%;
  margin-left: 5%;
  background-color: #f6f6f6;
  margin: 0 auto;
  margin-bottom: 100px;
}
.comments_edit .commentsBg {
  width: 100%;
  height: 44px;
  display: flex;
  position: relative;
}
.comments_edit .commentsBg .bgImg {
  width: 100%;
  height: 54px;
  position: absolute;
  z-index: 1;
}
.comments_edit .commentsBg .write {
  font-size: 28px;
  height: 60px;
  color: #4a4a4a;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 2;
}
.commentsBg .write img {
  width: 28px;
  height: 28px;
  margin: 0 10px;
}
.comments_edit .textArea {
  font-size: 28px;
  width: 100%;
  margin: 30px auto 20px;
  line-height: 44px;
  letter-spacing: 2px;
}

.submit {
  margin: 0 auto;
  margin-top: 20px;
  color: #fff;
  font-size: 24px;
  text-align: center;
  background: linear-gradient(#41a0f1 0%, #0a5b9f 100%);
  border-radius: 10px;
  width: 200px;
  padding: 5px;
  cursor: pointer;
}
/* .submit img {
  width: 100%;
  height: 100%;
}
.submit::after {
  border: none;
} */
.mod_action {
  position: absolute;
  right: 0;
  bottom: 120px;
}
.multiple {
  width: 120px;
  height: 40px;
  font-size: 20px;
  text-align: center;
  line-height: 40px;
}
.isMultiple {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.Multiple_bg {
  width: 100px;
  height: 80px;
}
.commentImg {
  width: 106px;
  height: 106px;
  border-radius: 50%;
  margin-right: 20px;
}
.commentCom {
  flex: 1;
}
.commentName {
  font-size: 24px;
  color: #5e5e5e;
  margin-bottom: 8px;
}
.commentText {
  font-size: 28px;
  color: #434343;
  margin-bottom: 16px;
  text-align: justify;
}
.commentTime {
  width: 100%;
  font-size: 24px;
  color: #979797;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.comments .commentItem {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 54px 0 28px;
  border-bottom: 1px solid #dcdcdc;
}

.commentTime div:nth-child(2) {
  display: flex;
  align-items: center;
}

.commentTime img {
  width: 24px;
  height: 24px;
  display: inline-block;
  margin-right: 10px;
}
</style>
